import {
  DeviceRadioCheckStatus,
  OverallRadioCheckStatus,
} from '@/enums/radiocheck';
import {
  LoRaWanGateway,
  SmartRadiatorThermostat,
} from '@/models/devices/Device';

export type RadioCheckPayload = {
  gateways: Array<LoRaWanGateway>;
  srts: Array<SmartRadiatorThermostat>;
  runId?: number;
};

export type EchoResult = {
  runId: number;
  notFoundSrts: Array<string>;
};

export class LoRaWanRadioCheck {
  public status?: OverallRadioCheckStatus;
  public runId?: number;
  public updatedAt?: string;
  public startedAt?: string;
  public result?: RadioCheckResponse;

  constructor() {
    this.status = undefined;
    this.runId = undefined;
    this.updatedAt = undefined;
    this.startedAt = undefined;
    this.result = undefined;
  }
}

export interface RadioCheckResponse {
  [key: string]: RadioCheckResult;
}

export interface RadioCheckResult {
  status: DeviceRadioCheckStatus;
  uplinkResponse: Record<string, UplinkReceptionQuality>;
  downlinkResponse: DownlinkReceptionQuality;
}

export class ReceptionQuality {
  public rssi?: number;
  public snr?: number;
  public status?: DeviceRadioCheckStatus;

  constructor() {
    this.rssi = undefined;
    this.snr = undefined;
    this.status = undefined;
  }
}

export class UplinkReceptionQuality extends ReceptionQuality {
  public updatedAt?: string;
  public spreadingFactor?: number;

  constructor() {
    super();
    this.updatedAt = undefined;
    this.spreadingFactor = undefined;
  }
}

export class DownlinkReceptionQuality extends ReceptionQuality {
  public updatedAt?: string;

  constructor() {
    super();
    this.updatedAt = undefined;
  }
}
